module.exports = __webpack_public_path__ + "static/media/img_male.b96b649f.svg";